import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../../../../stem-core/src/ui/Style";

import {LinkButton} from "../../../../../core/ui/LinkButton.jsx";
import {RollAnimatedBalance} from "../../../../common/RollAnimatedBalance";
import {Messages} from "../../../../Messages";
import {registerStyle, Theme} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {ADD_FUNDS_MINIMISED_HEIGHT} from "../../../WidgetConstants";
import {WidgetRoutes} from "../../../WidgetRoutes";
import {startDashboardFlow} from "../../../../panel/flows/FlowEntrypoint.js";


export const minimisedBalanceStyle = {
    fontSize: 14,
    fontWeight: "bold",
    width: "45px !important",
    height: "1em",
    color: () => Theme.props.WALLET_BALANCE_COLOR,
    transform: "translateY(0) !important",
    marginRight: 8,
};

class AddFundsMinimisedStyle extends StyleSheet {
    @styleRule
    container = {
        transition: this.themeProps.DEFAULT_TRANSITION,
        bottom: 0,
        zIndex: 1,
        height: ADD_FUNDS_MINIMISED_HEIGHT,
        padding: "12px 24px",
        position: "absolute",
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
    };

    @styleRule
    addFundsLink = {
        transition: this.themeProps.DEFAULT_TRANSITION,
        fontSize: 12,
        fontWeight: "400",
        color: this.themeProps.WALLET_3,
        whiteSpace: "nowrap",
        display: "flex",
        ":hover>:last-child": {
            color: this.themeProps.WHITE,
            opacity: 1,
        },
    };

    @styleRule
    dashboardLink = {
        color: this.themeProps.WHITE,
        " path ": {
            fillOpacity: 1,
        },
    };

    @styleRule
    balance = {
        ...minimisedBalanceStyle,
        opacity: 0,
    };

    @styleRule
    externalLink = {
        display: "inline-block",
        marginLeft: 6,
    }
}

// TODO: WOW, what is dumb fucking name
@registerStyle(AddFundsMinimisedStyle)
export class AddFundsMinimised extends UI.Element {
    static instance;

    render() {
        const {styleSheet} = this;

        return [
            <LinkButton href={WidgetRoutes.ADD_FUNDS} className={styleSheet.addFundsLink}>
                <RollAnimatedBalance ref="balance" className={styleSheet.balance} />
                <div>{Messages.blinkWallet}</div>
            </LinkButton>,
            <LinkButton className={styleSheet.dashboardLink} onClick={() => startDashboardFlow()}>
                {Messages.dashboard}
            </LinkButton>,
        ]
    }

    static getHeight() {
        return this.instance.getHeight();
    }

    onMount() {
        super.onMount();

        this.constructor.instance = this;
    }
}
